import { render, staticRenderFns } from "./COAMultiCurrencyAllocationInfoModal.vue?vue&type=template&id=62c3de1d&scoped=true&"
import script from "./COAMultiCurrencyAllocationInfoModal.vue?vue&type=script&lang=js&"
export * from "./COAMultiCurrencyAllocationInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3de1d",
  null
  
)

export default component.exports